import e from "react";
import { getIconColor as d } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const h = {
  display: "block"
}, v = ({ size: a = 16, useVw: t, useRem: c, color: l, withColor: o, removeClassName: n, disableSSR: i, style: r, ...m }) => {
  const p = r ? { ...h, ...r } : h;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: i }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-shenfenrenzheng", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), height: t ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (c ? "rem" : "px"), className: n ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: n ? "" : "24px-èº«ä»½è®¤è¯"
    },
    /* @__PURE__ */ e.createElement(
      "g",
      {
        className: n ? "" : "normal",
        fill: o ? d(l, 0, "#262933") : "#262933",
        datafollowfill: o ? d(l, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M8.273 7.339a2.162 2.162 0 1 0 0 4.323 2.162 2.162 0 0 0 0-4.323ZM7.612 9.5a.662.662 0 1 1 1.323 0 .662.662 0 0 1-1.323 0Zm-.751 2.65a2.217 2.217 0 0 0-2.216 2.217v.733c0 .82.664 1.483 1.483 1.483h4.4c.82 0 1.483-.664 1.483-1.483v-.733a2.217 2.217 0 0 0-2.216-2.217H6.86Zm-.716 2.217c0-.396.32-.717.716-.717h2.934c.396 0 .716.32.716.717v.716H6.146v-.716Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          d: "M13.028 9.067a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 0 1.6h-4.4a.8.8 0 0 1-.8-.8Zm2.267 5.066a.8.8 0 1 0 0 1.6h2.933a.8.8 0 0 0 0-1.6h-2.933Zm-.8-2.133a.8.8 0 0 1 .8-.8h2.933a.8.8 0 1 1 0 1.6h-2.933a.8.8 0 0 1-.8-.8Z"
        }
      ),
      /* @__PURE__ */ e.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M4.478 3.133a3.183 3.183 0 0 0-3.183 3.184v11.366a3.183 3.183 0 0 0 3.183 3.184h15.034a3.183 3.183 0 0 0 3.183-3.184V6.317a3.183 3.183 0 0 0-3.183-3.184H4.478ZM2.895 6.317c0-.875.709-1.584 1.583-1.584h15.034c.874 0 1.583.71 1.583 1.584v11.366c0 .875-.709 1.584-1.583 1.584H4.478a1.583 1.583 0 0 1-1.583-1.584V6.317Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, Z = v;
export {
  Z as default
};
